<template>
    <div>
    <div class="d-center-between flex-wrap">
        <left-text-border class="w-30 mb-3" leftText="订单号" v-model="searchData.oid" @enter="searchSubmit"/>
        <left-text-autocomplete  class="w-30 mb-3" leftText="门店名称" v-model="searchData.title"  @enter="searchSubmit" :storeType="3" v-if="isAdmin"/>
        <left-text-border class="w-30 mb-3" leftText="银行账户" v-model="searchData.truename" @enter="searchSubmit"/>
        
        <div class="w-30 mb-3 d-center-start" >
            <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width:260px;">
            <el-option v-for="item in timeChoose()" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
            <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                    v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                    range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                    end-placeholder="结束时间" />
            <el-date-picker type="date" v-model="timetime" class="w-100" size="small" 
                            v-show="timeType === 'timeArr'" placeholder="可选择一个日期"/>
        </div>
    </div>
    <div class="d-center mb-3">
        <el-button type="primary" size="small" @click="searchSubmit()" icon="el-icon-search">搜索</el-button>
        <el-button  size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
    </div>
    </div>
</template>

<script>
import { mapGetters,mapState,mapActions } from 'vuex'
  import { debounce } from "lodash";
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
        searchData:{
            title:'',                              //门店名称
            truename:'',                           //银行账户
            oid:'',                                //订单ID
            store_type:0,                          //门店类型
            store_id:'',                           //门店ID
            bank_card:'',                          //银行卡号
            add_time:''                            //按时间
        },
        timeType:'timeArr',
        timetime:'',
        timestamp: [],
        //是否搜索了订单
        isSearch:false,

    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    timeChoose() {
        let arr =  [
          {name:`提交时间`,value:'timeArr'},
          {name:`按时间段`,value:'timeFrame'},
        ];
        return arr
    },
      //提交搜索条件
      searchSubmit: debounce(function() {
        let data = {
          ...this.searchData,
        }
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
            let timeArr = this.timetime ? this.timetime.map(v => {return ((v.getTime() / 1000) + (this.$GFUN.isInArray([6,7,8],this.orderType) ? 28800 : 0))}) : [];
            data.date_in = timeArr.join(',');
            break;
          case 'timeFrame':
            data.date_in = start;
            data.date_out = end;
            break;
          case 'postTime':data.add_time = start + ',' + end; break;
          case 'dealTime':data.deal_time = start + ',' + end; break;
        }
        //保存是否搜索了订单
        this.isSearch = true;
        this.$emit('getSearchCon',data);
      },300),
       //重置搜索条件
      resetSearch: debounce(function(){
        //重置是否搜索了订单
        this.formData = {
            title:'',                              //门店名称
            truename:'',                           //银行账户
            oid:'',                                //订单ID
            store_type:0,                          //门店类型
            store_id:'',                           //门店ID
            bank_card:'',                          //银行卡号
            add_time:''                            //按时间
        };
        this.timeType = 'timeFrame';
        this.nameType = 'travel_title';
        this.timestamp = [];
        this.timetime = [];
        //重置搜索条件
        console.log(this.isSearch);
        if(this.isSearch){
          this.$emit('getSearchCon',this.formData);
          this.isSearch = false;
        }
      },300),
  }
};
</script>

<style lang="scss" scoped>
    .d-center{
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }
</style>
